import { Injectable } from '@angular/core';

import { AppConfig } from '../entities/configs/app.config';
import { MenuConfig } from '../entities/configs/menu.config';
import { User } from '../entities/apis/user';

@Injectable()
export class SessionService {
  get appConfig() {
    return this.get<AppConfig>('appConfig');
  }
  set appConfig(value: AppConfig) {
    this.set('appConfig', value);
  }
  get token() {
    return this.get<string>('token');
  }
  set user(user: User | null) {
    this.set('user', user);
  }
  get user() {
    return this.get<User>('user');
  }
  get menus() {
    return this.get<MenuConfig[]>('menus');
  }
  set menus(menus: MenuConfig[]) {
    this.set('menus', menus);
  }
  get<T>(name: string) {
    let value = sessionStorage.getItem(name);
    if (value) {
      return <any>JSON.parse(value);
    } else {
      return null;
    }
  }
  set(name: string, value: any) {
    if (value) {
      sessionStorage.setItem(name, JSON.stringify(value));
    } else {
      sessionStorage.removeItem(name);
    }
  }
}
